import * as i0 from '@angular/core';
import { Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { EquisUtilsModule } from '@tn-equis/core/utils';

var BadgeColours;
(function (BadgeColours) {
    BadgeColours["ORANGE"] = "orange";
    BadgeColours["GREEN"] = "green";
})(BadgeColours || (BadgeColours = {}));

var BadgeStatus;
(function (BadgeStatus) {
    BadgeStatus["WARNING"] = "warning";
    BadgeStatus["INFO"] = "info";
    BadgeStatus["SUCCESS"] = "success";
    BadgeStatus["ERROR"] = "error";
    BadgeStatus["NEUTRAL"] = "neutral";
})(BadgeStatus || (BadgeStatus = {}));

var BadgeTypes;
(function (BadgeTypes) {
    BadgeTypes["COLOR"] = "color";
    BadgeTypes["STATUS"] = "status";
})(BadgeTypes || (BadgeTypes = {}));

class EquisBadgeComponent {
    constructor() {
        this.color = BadgeColours.GREEN;
        this.status = BadgeStatus.NEUTRAL;
        this.type = BadgeTypes.COLOR;
    }
    get displayClass() {
        if (this.type === BadgeTypes.COLOR) {
            return `badge--color-${this.color}`;
        }
        return `badge--status-${this.status}`;
    }
}
EquisBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisBadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisBadgeComponent, selector: "z-badge , equis-badge", inputs: { text: "text", color: "color", status: "status", type: "type" }, ngImport: i0, template: "<div class=\"badge\" [ngClass]=\"displayClass\">\n  <span class=\"equis-badges badge__text\">{{ text }}</span>\n</div>\n", styles: [".badge{border-radius:16px 0;height:16px;max-width:calc(100% - 36px);min-height:16px;min-width:16px;padding:0 12px;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.badge--status-success{background-color:#e4f3e7;color:#19722c}.badge--status-warning{background-color:#fcf0ce;color:#735006}.badge--status-info{background-color:#e6eefa;color:#0d4ca6}.badge--status-error{background-color:#fbe9e9;color:#991515}.badge--status-neutral{background-color:#e8e8e8;color:#5b5b5b}.badge--color-orange{background-color:#fe5000;color:#fff}.badge--color-green{background-color:#19722c;color:#fff}.badge__text{align-items:center;color:inherit;display:flex;height:100%;overflow:hidden;white-space:nowrap}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-badge , equis-badge', template: "<div class=\"badge\" [ngClass]=\"displayClass\">\n  <span class=\"equis-badges badge__text\">{{ text }}</span>\n</div>\n", styles: [".badge{border-radius:16px 0;height:16px;max-width:calc(100% - 36px);min-height:16px;min-width:16px;padding:0 12px;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.badge--status-success{background-color:#e4f3e7;color:#19722c}.badge--status-warning{background-color:#fcf0ce;color:#735006}.badge--status-info{background-color:#e6eefa;color:#0d4ca6}.badge--status-error{background-color:#fbe9e9;color:#991515}.badge--status-neutral{background-color:#e8e8e8;color:#5b5b5b}.badge--color-orange{background-color:#fe5000;color:#fff}.badge--color-green{background-color:#19722c;color:#fff}.badge__text{align-items:center;color:inherit;display:flex;height:100%;overflow:hidden;white-space:nowrap}\n"] }]
        }], propDecorators: { text: [{
                type: Input
            }], color: [{
                type: Input
            }], status: [{
                type: Input
            }], type: [{
                type: Input
            }] } });

class EquisStatusBadgeComponent {
    constructor() {
        this.status = BadgeStatus.NEUTRAL;
        this.badgeType = BadgeTypes.STATUS;
    }
}
EquisStatusBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStatusBadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisStatusBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisStatusBadgeComponent, selector: "z-status-badge , equis-status-badge", inputs: { text: "text", status: "status" }, ngImport: i0, template: "<equis-badge [status]=\"status\" [text]=\"text\" [type]=\"badgeType\"></equis-badge>\n", styles: [""], dependencies: [{ kind: "component", type: EquisBadgeComponent, selector: "z-badge , equis-badge", inputs: ["text", "color", "status", "type"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStatusBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-status-badge , equis-status-badge', template: "<equis-badge [status]=\"status\" [text]=\"text\" [type]=\"badgeType\"></equis-badge>\n" }]
        }], propDecorators: { text: [{
                type: Input
            }], status: [{
                type: Input
            }] } });

class EquisBadgesModule {
    constructor() { }
    static forRoot() {
        return {
            ngModule: EquisBadgesModule,
        };
    }
}
EquisBadgesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisBadgesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisBadgesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisBadgesModule, declarations: [EquisStatusBadgeComponent, EquisBadgeComponent], imports: [CommonModule, EquisUtilsModule], exports: [EquisStatusBadgeComponent, EquisBadgeComponent] });
EquisBadgesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisBadgesModule, imports: [CommonModule, EquisUtilsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisBadgesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisStatusBadgeComponent, EquisBadgeComponent],
                    imports: [CommonModule, EquisUtilsModule],
                    exports: [EquisStatusBadgeComponent, EquisBadgeComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeColours, BadgeStatus, BadgeTypes, EquisBadgeComponent, EquisBadgesModule, EquisStatusBadgeComponent };
